import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './components/App'
import enums from './mixins/enums'
import router from './router'
import store from './store'
import { pluginsAssociator, pluginList } from 'utils/VuePluginHelper'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

// Sentry.io bug monitoring
if ('development' != process.env.NODE_ENV) {
  Sentry.init({
    Vue,
    dsn: "https://c71a1793dbb84ad69767002095114786@o1038849.ingest.sentry.io/6007469",
    environment: process.env.NODE_ENV,
    beforeSend(event, hint) {
      const error = hint.originalException;
  
      // Ignore 4xx errors
      if (
        error && 
        error.isAxiosError && 
        error.response && 
        error.response.status && 
        Math.floor(error.response.status/100) == 4
      ) {
        return null;
      }
  
      return event;
    },
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["localhost", "agency.sofradom.test", "agency.sofradom.dev", "agency.sofradom.fr", /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  })
}

Vue.mixin({
  methods: {
    addNotification(message, type, timeout = 5000, style = 'simple') {
      const typeToClass = {
          'success': 'complete-success',
          'error': 'danger'
      }

      $('body').pgNotification({
          style: style,
          type: typeToClass[type],
          message: message,
          timeout: timeout,
      }).show()
    },
    truncate(string, length = 24) {
      return _.truncate(string, {'length': length})
    }
  }
})
Vue.mixin(enums)

// automaticly trigger Pages bindings from vendor script
// after every route change
router.afterEach((to, from) => {
  // re-trigger load window event
  // so that `Pages.js` will checkup new HTML
  // NOTE: `setTimeout` with 0ms will execute callback
  // on next browser webpage rendering
  // setTimeout(_ => $(window).load(), 0)
  Vue.nextTick(_ => $(window).load())
})

Vue.use(pluginsAssociator, pluginList)

sync(store, router)

const app = new Vue({
  router,
  store,
  ...App
})

if (process.env.NODE_ENV !== 'production') {
  window.Vue = Vue
  window.app = app
}

export { app, router, store }



// WEBPACK FOOTER //
// ./client/app.js